'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

import S from '../Table.module.scss'

export interface TableRowProps extends ComponentPropsWithoutRef<'tr'> {}

export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <tr {...props} ref={ref} className={classNames(S.row, className)}>
        {children}
      </tr>
    )
  }
)

TableRow.displayName = 'Table.Row'
